import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stagesActions from '../../../actions/stages';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';
import StageParticipantUploadForm from '../../../components/stage/stage-participants-upload-form';

class StageParticipantsUploadContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/stages';
    }

    onSuccessSubmit() {
        // alert('Saved');
    }

    fetchItem(id) {
        return this.props.actions.fetchStage(id)
    }

    render() {
        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.participantsUpload}</header>
                <div className="panel-body">
                    <StageParticipantUploadForm submit={(values) => {
                        return this.props.actions.uploadParticipants(this.props.params.itemId, values)
                    }} onSuccessSubmit={this.onSuccessSubmit.bind(this)}/>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {loading: state.stage.stage.loading, stage: state.stage.stage.item};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stagesActions
        }, dispatch)
    };
})(StageParticipantsUploadContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/stage/stage-participants-upload-container.js